import { render, staticRenderFns } from "./EditProductStock.vue?vue&type=template&id=5d8b73a9&scoped=true&"
import script from "./EditProductStock.vue?vue&type=script&lang=js&"
export * from "./EditProductStock.vue?vue&type=script&lang=js&"
import style0 from "./EditProductStock.vue?vue&type=style&index=0&id=5d8b73a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8b73a9",
  null
  
)

export default component.exports